import { RefHistorical, RefTask } from '../../framework/infra'
import EmploymentTask from './EmploymentTask'

export default class EmploymentTasks extends RefHistorical {
    static ref = EmploymentTask
}
